<script setup>
import { ref } from 'vue'
import axios from 'axios'

const busy = ref(false)
const error = ref(false)

async function openMaterials() {
    if (busy.value) return
    busy.value = true
    error.value = false
    let materialsTab
    try {
        // Open during the click so the browser does not block the new tab after awaiting the API.
        materialsTab = window.open('about:blank', '_blank')
        if (!materialsTab) throw new Error('popup-blocked')
        materialsTab.opener = null
        const { data } = await axios.get('/api/materials/access', { headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` } })
        const destination = new URL(data.start_url)
        if (destination.protocol !== 'https:') throw new Error('unavailable')
        if (materialsTab.closed) return
        materialsTab.location.replace(destination.href)
    } catch {
        if (materialsTab && !materialsTab.closed) materialsTab.close()
        error.value = true
    } finally {
        busy.value = false
    }
}
</script>

<template>
    <v-btn variant="outlined" color="#00C2A8" size="small" prepend-icon="mdi-package-variant-closed"
           :loading="busy" :disabled="busy" aria-label="Materials (se abre en una nueva pestaña)" @click="openMaterials">
        Materials
    </v-btn>
    <v-snackbar v-model="error" color="error" :timeout="8000" role="alert">
        No se puede abrir Materials. Permite las ventanas emergentes y comprueba tu sesión o contacta con el administrador.
        <template #actions>
            <v-btn variant="text" @click="error = false">Cerrar</v-btn>
        </template>
    </v-snackbar>
</template>
